import { KnowledgeDocument } from '@/types/knowledge';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface DocumentViewerProps {
  document: KnowledgeDocument;
}

export function DocumentViewer({ document }: DocumentViewerProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-3xl font-bold">{document.title}</h1>
          <p className="text-muted-foreground mt-2">{document.category}</p>
        </div>
        <Badge>{document.status}</Badge>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Problema</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="whitespace-pre-wrap">{document.problem}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Solução</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="whitespace-pre-wrap">{document.solution}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Informações</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Versão:</span>
            <span>{document.currentVersion}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Protocolos:</span>
            <span>{document.sourceProtocols.join(', ')}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Path:</span>
            <span className="font-mono text-xs">{document.path}</span>
          </div>
          {document.metadata.model && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Modelo:</span>
              <span>{document.metadata.model}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
